import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [
		createPersistedState({
			key: 'colocess_website', 
			paths: [
				'user.token',
				'user.userInfo',
			], 
			storage: { // 存储方式定义 
				getItem: (key) => localStorage.getItem(key), // 获取  
				setItem: (key, value) => localStorage.setItem(key, value), // 存储  
				removeItem: (key) => localStorage.removeItem(key) // 删除  
			}
		})
	],
  modules: {
    user,
  }
})

export default store
